var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgApplicants(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 31,
    viewBox: "0 0 24 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2353_8772)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.8439 15.5C13.7995 15.5 15.3848 13.9147 15.3848 11.9591C15.3848 10.0035 13.7995 8.41821 11.8439 8.41821C9.88829 8.41821 8.30298 10.0035 8.30298 11.9591C8.30298 13.9147 9.88829 15.5 11.8439 15.5Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.5697 23.2231C16.5697 20.5604 14.4089 18.3997 11.7463 18.3997C9.08363 18.3997 6.92285 20.5604 6.92285 23.2231",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.6328 1.19702H5.06868C2.74354 1.19702 0.858643 3.08192 0.858643 5.40706V25.5929C0.858643 27.9181 2.74354 29.803 5.06868 29.803H18.6328C20.9579 29.803 22.8428 27.9181 22.8428 25.5929V5.40706C22.8428 3.08192 20.9579 1.19702 18.6328 1.19702Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2353_8772"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 23.3783,
    height: 30,
    fill: "white",
    transform: "translate(0.161621 0.5)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgApplicants);
export default __webpack_public_path__ + "static/media/applicants.024fef8269e831439f3bf5cdcd70b892.svg";
export { ForwardRef as ReactComponent };